import Tab from "../model/Tab";
import {EventBus} from "../events/event.bus";
import {EVENT_APP_NAVIGATE} from "../events/app.events";
import {useResultPageStore} from "../stores/ResultPageStore";
import {JOB_STATE_DOWNLOAD, JOB_STATE_COMPLETE, JOB_STATE_FAILED, JOB_STATE_INCOMPLETE, JOB_STATE_ZIP} from "../const/job.const";
import ApiManager from "./ApiManager";
import {EVENT_JOB_FAIL} from "../events/job.events";
import OutputSelectionManager from "./OutputSelectionManager";
import Analytics from "../util/Analytics";
import DownloadCookieManager from "./DownloadCookieManager";
import {testIsNonEmptyString} from "../../../../../../lib/test-and-assert/test-base";

function delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

class DownloadManager {

    listener = false;

    constructor() {
    }

    async downloadOutput(output, job) {
        job.downloadedOutputs.length = 0;
        job.state = JOB_STATE_DOWNLOAD;
        
        output.status = 'downloading';
        Analytics.send('result_download', 'download_single');

        if(testIsNonEmptyString(job?.apiJob?.sat?.download_password)){
            DownloadCookieManager.setDownloadCookie(job.apiJob.sat.download_password);
        }

        if (!job.downloadedOutputs.includes(output.id)) {
            job.downloadedOutputs.push(output.id);
        }
        
        window.location = output.download_uri;
        
        await delay(2000);
        output.status = 'downloaded';

        await delay(2000);
        output.status = 'enabled';
    }

    async downloadSelectedOutputsAsZip(jobId) {
        this.store = useResultPageStore();
        Analytics.send('result_download', 'zip_selected_outputs_start', this.store.getJobById(jobId));

        let job = this.store.getJobById(jobId);
        
        job.state = JOB_STATE_ZIP;
        job.downloadedOutputs.length = 0;

        let outputs = OutputSelectionManager.getSelectedOutputs(job);
        await this._startZip(job, outputs);
    }

    async downloadJobAsZip(jobId) {
        this.store = useResultPageStore();
        let job = this.store.getJobById(jobId);
        Analytics.send('result_download', 'zip_job_start', job);

        if (job.zipJob !== null && job.zipJob.status.code === 'completed' && job.zipJob.input.length === job.apiJob.output.length) {
            Analytics.send('result_download', 'zip_job_redownload', job);

            this.downloadZipJob(job);
            return;
        }

        job.state = JOB_STATE_ZIP;
        job.downloadedOutputs.length = 0;

        let outputs = job.apiJob.output;

        await this._startZip(job, outputs);
    }

    async _startZip(job, outputs) {
        let zipInputs = [];

        outputs.forEach((output) => {
            zipInputs.push({
                type: 'remote',
                source: output.uri,
                engine: 'zip',
            });

            if (!job.downloadedOutputs.includes(output.id)) {
                job.downloadedOutputs.push(output.id);
            }
        })

        let zipJob = await ApiManager.create();

        await ApiManager.addInputs(zipJob,  zipInputs);
        await ApiManager.start(zipJob, {
            target: 'zip',
            category: 'archive',
            options: {
                allow_multiple_outputs: false,
            },
        });

        await this._waitUntilComplete(zipJob);

        job.zipJob = await ApiManager.get(zipJob);
        Analytics.send('result_download', 'zip_complete', job);

        this.downloadZipJob(job);
    }

    async downloadZipJob(job) {
        if(testIsNonEmptyString(job.zipJob.sat.download_password)){
            DownloadCookieManager.setDownloadCookie(job.zipJob.sat.download_password);
        }

        window.location = job.zipJob?.output[0].download_uri;

        job.state = JOB_STATE_DOWNLOAD;

    }

    async _waitUntilComplete(job, incomplete = 0) {
        return new Promise((resolve, reject) => {

             async function _waitUntilComplete(job, incomplete = 0) {
                let apiJob = await ApiManager.get(job);
                if (null === apiJob) {
                    resolve();
                    return;
                }

                if (apiJob.status.code === JOB_STATE_FAILED) {
                    Analytics.send('result_download', 'zip_failed', {apiJob: apiJob});

                    EventBus.$emit(EVENT_JOB_FAIL, {});

                    resolve();
                    return;
                }

                if (apiJob.status.code === JOB_STATE_COMPLETE) {
                    Analytics.send('result_download', 'zip_success', {apiJob: apiJob});

                    resolve();
                    return;
                }

                if (apiJob.status.code === JOB_STATE_INCOMPLETE) {
                    if (incomplete > 60) {
                        job.state = JOB_STATE_FAILED;
                        Analytics.send('result_download', 'zip_failed_incomplete', {apiJob: apiJob});


                        resolve();
                        return;
                    }

                    setTimeout(() => {
                        _waitUntilComplete(job, ++incomplete);
                    }, 1000);

                    return;
                }

                setTimeout(() => {
                    _waitUntilComplete(job);
                }, 1000);

                return;
            }

            _waitUntilComplete(job, incomplete);
        })
    }
}

export default new DownloadManager()